module.exports = __webpack_public_path__ + "static/media/purpleZzz.35a8da06.svg";